import React, { useState } from "react";
import { useSelector } from "react-redux";
import { Table, Row, Col, Button } from "react-bootstrap";
import Pagination from "../components/Pagination"; // Ensure this path is correct
import "./listings/Pages.css";

const BoxesTable = ({
  showConnectedTable,
  setShowConnectedTable,
  showDisconnectedTable,
  setShowDisconnectedTable,
  showTotalTable,
  setShowTotalTable,
  showUnpaidTable,
  setShowUnpaidTable,
}) => {
  const { groupedCustomerData, status, error } = useSelector(
    (state) => state.groupData
  );

  // --- Pagination State ---
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10; // Set to 5 as requested

  // Helper function to calculate pagination slices
  const getPaginatedData = (data) => {
    const startIndex = (currentPage - 1) * itemsPerPage;
    const slicedData = (data || []).slice(startIndex, startIndex + itemsPerPage);
    const totalPages = Math.ceil((data?.length || 0) / itemsPerPage);
    return { slicedData, totalPages, startIndex };
  };

  // Centralized toggle handler to reset pagination when switching tables
  const toggleTable = (target) => {
    setCurrentPage(1); // Reset to page 1 on every toggle
    setShowConnectedTable(target === "connected");
    setShowDisconnectedTable(target === "disconnected");
    setShowTotalTable(target === "total");
    setShowUnpaidTable(target === "unpaid");
  };

  // Reusable Table Renderer
  const renderTable = (title, data, type) => {
    if (!data || data.length === 0) return null;

    const { slicedData, totalPages, startIndex } = getPaginatedData(data);

    return (
      <div className="mt-4">
        <h3 className="mb-3 fw-bold">{title}</h3>
        <Table striped bordered hover responsive className="mb-0">
          <thead className="table-secondary">
            <tr>
              <th className={`${type}_box_heading`}>S.No</th>
              <th className={`${type}_box_heading`}>Customer No</th>
              <th className={`${type}_box_heading`}>Name</th>
              <th className={`${type}_box_heading`}>Phone</th>
              <th className={`${type}_box_heading`}>Area</th>
              <th className={`${type}_box_heading`}>Plan</th>
              <th className={`${type}_box_heading`}>Box No</th>
            </tr>
          </thead>
          <tbody>
            {slicedData.map((customer, index) => (
              <tr key={customer.id || index}>
                {/* Continuous Serial Number calculation */}
                <td>{startIndex + index + 1}</td>
                <td>{customer.customer_no}</td>
                <td>{customer.name}</td>
                <td>{customer.phone}</td>
                <td>{customer.area_name}</td>
                <td>{customer.plan_name}</td>
                <td>{customer.box_no}</td>
              </tr>
            ))}
          </tbody>
        </Table>
        
        {/* Pagination Control */}
        <div className="p-3 d-flex justify-content-between align-items-center bg-light border border-top-0">
          <span className="text-muted small">
            Showing {startIndex + 1} to {Math.min(startIndex + itemsPerPage, data.length)} of {data.length} entries
          </span>
          <Pagination
            currentPage={currentPage}
            totalPages={totalPages}
            onPageChange={setCurrentPage}
          />
        </div>
      </div>
    );
  };

  return (
    <>
      <Row className="py-3">
        <Col lg="5" xs="12" className="card workout-card border-0">
          <Row className="d-flex w-100">
            <Col lg="6" className="workout-info">
              <h2 className="mb-3 fw-bold">Boxes</h2>
              <ul className="legend">
                <li>
                  <Button className="legend-box intake" onClick={() => toggleTable("total")}></Button>
                  <span className="ms-2">Total Boxes</span>
                </li>
                <li>
                  <Button className="legend-box activity" onClick={() => toggleTable("connected")}></Button>
                  <span className="ms-2">Active Boxes</span>
                </li>
                <li>
                  <Button className="legend-box burned" onClick={() => toggleTable("disconnected")}></Button>
                  <span className="ms-2">Disconnect Boxes</span>
                </li>
                <li>
                  <Button className="legend-box unpaid" onClick={() => toggleTable("unpaid")}></Button>
                  <span className="ms-2">Unpaid Boxes</span>
                </li>
              </ul>
            </Col>
            <Col lg="6" className="workout-bubbles justify-content-center">
              {status === "loading" && <p>Loading...</p>}
              {status === "failed" && <p className="text-danger">Error: {error}</p>}
              {status === "succeeded" && groupedCustomerData && (
                <>
                  <div
                    className="circle burned-circle circle-blink"
                    onClick={() => toggleTable("disconnected")}
                    style={{ cursor: 'pointer' }}
                  >
                    <span>
                      {groupedCustomerData.disconnected_boxes || 0}
                      <br />
                      Boxes
                    </span>
                  </div>
                  <div
                    className="circle activity-time circle-blink"
                    onClick={() => toggleTable("connected")}
                    style={{ cursor: 'pointer' }}
                  >
                    <span>
                      {groupedCustomerData.connected_boxes || 0}
                      <br />
                      Boxes
                    </span>
                  </div>
                  <div
                    className="circle intake-circle circle-blink"
                    onClick={() => toggleTable("total")}
                    style={{ cursor: 'pointer' }}
                  >
                    <span>
                      {groupedCustomerData.total_boxes || 0}
                      <br />
                      Boxes
                    </span>
                  </div>
                  <div
                    className="circle unpaid-circle circle-blink"
                    onClick={() => toggleTable("unpaid")}
                    style={{ cursor: 'pointer' }}
                  >
                    <span>
                      {groupedCustomerData.unpaid_boxes || 0}
                      <br />
                      Boxes
                    </span>
                  </div>
                </>
              )}
            </Col>
          </Row>
        </Col>
      </Row>

      {/* Data Display Logic */}
      {status === "succeeded" && groupedCustomerData && (
        <Row>
          <Col xs="12">
            {showConnectedTable && renderTable("Connected Boxes", groupedCustomerData.connected_boxes_data, "connected")}
            {showDisconnectedTable && renderTable("Disconnected Boxes", groupedCustomerData.disconnected_boxes_data, "disconnected")}
            {showUnpaidTable && renderTable("Unpaid Boxes", groupedCustomerData.unpaid_boxes_data, "unpaid")}
            {showTotalTable && renderTable("Total Boxes", groupedCustomerData.total_boxes_data, "total")}
          </Col>
        </Row>
      )}
    </>
  );
};

export default BoxesTable;